import React from "react";
import { Helmet } from "react-helmet";
const GraphicdesignHelmet = ({ title }) => {
  return (
    <Helmet>
      <title>
        Professional Graphic Design Services in USA
      </title>
      <meta
        name="description"
        content="Top-rated graphic design services in USA. Reach out today to elevate your brand with custom logo, business card, brand identity, UI/UX, and animation designs."
      />
    </Helmet>
  );
};

export default GraphicdesignHelmet;
